import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useEffect, useState } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import ExpandCollapseCell from 'src/components/custom-cells/ExpandCollapseCell';
import PopUp from 'src/components/design-system/PopUp';
import { InvoiceContext } from 'src/sections/invoice_details/InvoiceDetailsContext';
import { useContextSelector } from 'use-context-selector';

const InvoiceMpaDetailCell = (props: GridCellProps) => {
  const { dataItem, field = '' } = props;
  const [value, setValue] = useState(dataItem[field] || false);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setValue(dataItem[field] || false);
  }, [dataItem, field]);

  const isInvoiceBudgetPeriodDirty = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceBudgetPeriodDirty
  );
  const setInvoiceBudgetPeriods = useContextSelector(
    InvoiceContext,
    (value) => value.setInvoiceBudgetPeriods
  );

  const expandedBudgetPeriodIds = useContextSelector(
    InvoiceContext,
    (value) => value.expandedBudgetPeriodIds
  );
  const setExpandedBudgetPeriodIds = useContextSelector(
    InvoiceContext,
    (value) => value.setExpandedBudgetPeriodIds
  );

  let { rowId } = dataItem;

  const handleExpendClick = useCallback(() => {
    if (!isInvoiceBudgetPeriodDirty) {
      const newValue = !value;
      setValue(newValue);

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      const newTimeoutId = setTimeout(() => {
        setInvoiceBudgetPeriods((prev) =>
          [...prev].map((item) =>
            item?.rowId === rowId ? { ...item, expanded: !item.expanded } : item
          )
        );
        if (expandedBudgetPeriodIds.includes(dataItem.rowId)) {
          const updatedItems = expandedBudgetPeriodIds.filter((item) => item !== dataItem.rowId);
          setExpandedBudgetPeriodIds(updatedItems);
        } else {
          setExpandedBudgetPeriodIds((prev) => [...prev, dataItem.rowId]);
        }
      }, 500);

      setTimeoutId(newTimeoutId);
    }
  }, [
    dataItem.rowId,
    expandedBudgetPeriodIds,
    isInvoiceBudgetPeriodDirty,
    rowId,
    setExpandedBudgetPeriodIds,
    setInvoiceBudgetPeriods,
    timeoutId,
    value,
  ]);

  return (
    <GridCellBase {...props} className="k-hierarchy-cell" disableToolTip>
      <PopUp
        content={<PopUpContentWrapper type="Error" contents={['Save required']} />}
        show={isInvoiceBudgetPeriodDirty}
      >
        <ExpandCollapseCell
          title={isInvoiceBudgetPeriodDirty ? '' : 'Expand/Collapse'}
          expand={value}
          onExpand={handleExpendClick}
          plusIconColor={isInvoiceBudgetPeriodDirty ? '#aaa' : '#0e80b4'}
          minusIconColor={isInvoiceBudgetPeriodDirty ? '#aaa' : '#0e80b4'}
        />
      </PopUp>
    </GridCellBase>
  );
};

export default InvoiceMpaDetailCell;
